import {_} from 'vue-underscore';
import moment from 'moment';
import sysMessages from '@/helpers/system.message';

const user = localStorage.getItem("ACCESS") ? JSON.parse(localStorage.getItem("ACCESS")) : "";
const secretKey = user.secretKey ? JSON.parse(decodeURIComponent(escape(window.atob(user.secretKey)))) : "";
const BASE_URL = process.env.VUE_APP_BASE_URL;
export default {
    logIn(response, sync) {
        this.setLocalStorage(response.data);
        
        //Si está sincronizando datos se mantiene en la misma vista, sino se redirige al home.
        sync ? location.reload() : window.location.href = BASE_URL + "/home";
    },
    setLocalStorage(response) {
        localStorage.setItem("ACCESS", JSON.stringify(response));
        localStorage.setItem("SESSION", moment());
    },
    logOut(param) {

        localStorage.removeItem('ACCESS');
        localStorage.removeItem('SESSION');
        if (param) {
            sysMessages.getMessage('Su sesión ha expirado', 'info');
            setTimeout(() => {
                window.location.href = BASE_URL + "/login";
            }, 2000);
        } else {
            window.location.href = BASE_URL + "/login";
        }

    },
    sessionExpiration() {
        try {

            if (this.logged()) {
                let lastSession = localStorage.getItem('SESSION');
                let now = moment();
                let removeSession = now.diff(lastSession, 'hours') > 24 ? true : false;
                return removeSession
            }

        } catch (error) {
            console.log(error)
            return false;
        }
    },
    getUser() {
        try {
            return user;
        } catch (e) {
            return {};
        }
    },
    access() {
        try {
            return JSON.parse(decodeURIComponent(escape(window.atob(user.secretKey))));
        } catch (e) {
            return {};
        }
    },
    mapAccess(routerName) {
        try {
            let access = [];
            secretKey.access.departments.forEach(departments => {
                departments.menu.forEach(menu => {
                    if (menu.name && menu.name.trim().length > 0 && !_.contains(access, menu.name.trim())) {
                        access.push(menu.name.trim());
                    }
                    if (menu.submenu) {
                        menu.submenu.forEach(submenu => {
                            if (!_.contains(submenu.menu)) {
                                access.push(submenu.name);
                            }
                        });
                    }
                });
            });
            return access.includes(routerName);
        } catch (e) {
            return false;
        }
    },
    getActions(routerName) {
        try {
            let actions = {};
            secretKey.access.departments.forEach(departments => {
                departments.menu.forEach(menu => {
                    if (menu.name && menu.name.trim().length > 0 && menu.name == routerName) {
                        actions = menu.actions;
                    }
                    if (menu.submenu) {
                        menu.submenu.forEach(submenu => {
                            if (submenu.name == routerName) {
                                actions = submenu.actions;
                            }
                        });
                    }
                });
            });
            return actions;
        } catch (e) {
            return false;
        }
    },
    logged() {
        try {
            return user.secretKey ? true : false;
        } catch (e) {
            return false;
        }
    },
    getMenu() {
        try {
            const routerName = window.location.pathname.toString().toLowerCase().trim().split('/');
            return _.sortBy(_.find(secretKey.access.departments, find => {
                return _.contains(routerName, find.url.toLowerCase().trim());
            }).menu, (sort)=> sort.caption);
        } catch (e) {
            return false;
        }
    },
    getDepartments() {
        try {
            return _.sortBy(secretKey.access.departments, (sort)=> sort.caption);
        } catch (e) {
            return false;
        }
    },
    getSpecialsAccess(routerName){
        try {
            let specials = [];
            secretKey.access.departments.forEach(departments => {
                departments.menu.forEach(menu => {
                    if (menu.name && menu.name.trim().length > 0 && menu.name == routerName) {
                        specials = menu.specials;
                    }
                    if (menu.submenu) {
                        menu.submenu.forEach(submenu => {
                            if (submenu.name == routerName) {
                                specials = submenu.specials;
                            }
                        });
                    }
                });
            });
            return specials;
        } catch (e) {
            return false;
        }
    },
    setSpecialsAccess(routerName, action){
        try {
            let specials = [];
            secretKey.access.departments.forEach(departments => {
                departments.menu.forEach(menu => {
                    if (menu.name && menu.name.trim().length > 0 && menu.name == routerName) {
                        specials = menu.specials;
                    }
                    if (menu.submenu) {
                        menu.submenu.forEach(submenu => {
                            if (submenu.name == routerName) {
                                specials = submenu.specials;
                            }
                        });
                    }
                });
            });
            return _.filter(specials, (filter)=>{ return filter.selector == action }).length > 0 ? true : false;
        } catch (e) {
            return false;
        }
    }
};